/**
 * The frontend's field components.
 *
 * The registry and the renderers that need nothing from the app live in
 * @auger/ui (fields/registry, fields/defaults). This file registers the ones that
 * do: the reference and junction renderers (they read the app's stores and
 * client), markdown (the editor), and the filter picker. It also re-exports the
 * registry's API, so callers keep importing from here.
 */
import "./junction"
import "./reference"
import { registerDefaultFieldComponents } from "@auger/ui/fields/defaults"
import { registerFieldComponents } from "@auger/ui/fields/registry"
import AttachmentField from "./reference/AttachmentField.vue"
import AttachmentInput from "./reference/AttachmentInput.vue"
import ContactField from "./reference/ContactField.vue"
import ContactsInput from "./reference/ContactsInput.vue"
import ReferenceSelect from "./reference/ReferenceSelect.vue"
import SelectReferenceField from "./reference/SelectReferenceField.vue"
import TimeField from "./reference/TimeField.vue"
import TimeInput from "./reference/TimeInput.vue"
import FilterInput from "./value/FilterInput.vue"
import MarkdownField from "./value/MarkdownField.vue"
import MarkdownInput from "./value/MarkdownInput.vue"

export { getComponent, isGlyphStatus } from "@auger/ui/fields/registry"

registerDefaultFieldComponents()

// What stays in the app: the renderers that read its stores, its client, or the
// editor. The reference chips (and their searches) are in reference/ and
// junction/, which register themselves into the package's registries on import.
registerFieldComponents({
  markdown: { cell: MarkdownField, form: MarkdownInput },
  filter: { form: FilterInput },

  user: { cell: SelectReferenceField },
  attachment: { cell: AttachmentField, form: AttachmentInput },
  contact: { cell: ContactField, form: ContactsInput }, // and its kinds: email, phone, url, location, socials
  time: { cell: TimeField, form: TimeInput }, // and its kinds: instant, event, hours, slot, lifetime
  type: { form: ReferenceSelect },
  schema: { cell: SelectReferenceField, form: ReferenceSelect },
})
